import service from "../../images/landscap.png";
import React from "react";

const ServiceDetail = () => {
  return (
    <>
      <div className="container">
        <h6 className="service-head "> ALL SERVICES</h6>
        <div className="row">
          <div className="col-lg-5">
            <img
              src={service}
              height={300}
              className="w-100 br-20"
              alt={service}
            />
            <h3 className="color-primary  text-center mt-2">
              Landscape Design
            </h3>
          </div>
          <div className="col-lg-7 mt-5 mb-5">
            <h3>Transform Your Outdoor Space with Expert Landscape Design</h3>
            <p>
              At AFS DOTE, we bring nature’s beauty and human creativity
              together to craft breathtaking outdoor spaces. Whether you're
              dreaming of a serene garden, a vibrant patio, or a functional
              outdoor living area, our team of skilled designers and
              horticulture experts will turn your vision into reality.
            </p>
            <p>From concept to completion, we specialize in:</p>
            <ul>
              <li>
                Custom Garden Design – Tailored to your style and environment
              </li>
              <li>
                Hardscaping Solutions – Patios, pathways, retaining walls, and
                more.
              </li>
              <li>
                Sustainable Landscaping – Eco-friendly designs that conserve
                water and support local ecosystems.
              </li>
              <li>
                Outdoor Lighting & Water Features – Enhance ambiance with
                stunning details. Experience personalized service, innovative
                solutions, and enduring beauty in every project. Let's cultivate
                your perfect outdoor retreat today.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetail;
